import {showPopup} from './../initHelper/initPopups';

export default function exceptionHandler() {
    window.onerror = enErrorHandler;
    window.addEventListener('exceptionPopupClosed', function (e) {
        // reinit exception listener
        window.onerror = enErrorHandler;
    });
}

function enErrorHandler(errorMsg) {

    // See https://stackoverflow.com/a/50387233
    if (errorMsg.includes('ResizeObserver loop')) {
        return;
    }
    window.onerror = true; // disable other errors while message modal is open
    showPopup('Ein Fehler ist aufgetreten', 'Bitte versuchen Sie es erneut oder nehmen Sie mit uns Kontakt auf', 'Erneut versuchen');
    
    return false;
}
